import { Component } from "solid-js";

export interface BlurProps {
  class?: string | undefined;
}

export const Blur: Component<BlurProps> = (_props) => {
  return <div class="backdrop-blur-5v fixed top-0 right-0 bottom-0 left-0" />;
};
